import { Component, ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService, AlertService } from '../_services';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { FormControl, Validators, FormGroup, FormArray } from '@angular/forms';
import { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';





@Component({
  selector: 'app-marks',
  templateUrl: './marks.component.html',
  styleUrls: ['./marks.component.css']

})
export class MarksComponent implements OnInit {
  public alertOption: SweetAlertOptions = {};
  loading = false;
  submitted = false;
  returnUrl: string;
  imagePath: string;
  student_data: any;
  comments = new FormControl();
  mark = new FormControl('', [Validators.required]);

  students = [];
  studentName: string
  studentCode: string
  feed: any;
  localData = {};
  authenticationService: any;
  private sub: any;
  practical_id: number
  student_id: number
  markss = [];
  maxMarks: number
  isError = false
  errorMsg; string
  public showWebcam = true;
  @ViewChild('setmarkSwal') private setmarkSwal: SwalComponent;
  @ViewChild('markSwal') private markSwal: SwalComponent;
  @ViewChild('submitSwal') private submitSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;





  constructor(private route: ActivatedRoute,
    private router: Router,
    private studentService: StudentService,
    private alertService: AlertService,
    private globals: Globals,
  ) { }

  std_data: any

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.practical_id = +params['id'];
      this.student_id = +params['stdid']
    });
    this.localData = JSON.parse(localStorage.getItem('currentUser'));
    this.std_data = JSON.parse(sessionStorage.getItem('pkshn_vc_settings'))

    this.returnUrl = '/';

    // this.toggleWebcam();

    this.getStudentsData();
  }
  // private toggleWebcam() {
  //   this.showWebcam = !this.showWebcam;

  // }

  private getStudentsData() {
    this.submitted = true;
    this.studentService.practicalNos(this.globals.root_url, this.localData['usercode'], this.student_id, this.practical_id, this.localData['id'], this.localData['exam_id'])
      .pipe(first())
      .subscribe(

        data => {
          //console.log(data);
          if (data.code == 1000) {
            this.students = data.nos;
            this.maxMarks = data.maxmarks

          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
          }
          else if (data.code == 1001) {
            this.isError = true;
            this.errorMsg = 'You do not have any Practicular for this student !!';
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      )
  }

  status: string
  number


  method(event, chapter_id) {

    if(event.target.value == ''){
      return
    }
    else if (event.target.value > this.maxMarks) {
      this.markSwal.show();
      return;
    } else {
      this.markss.push({ "chapter_id": chapter_id, "marksgiven": event.target.value });       

    }
  }



  public onSubmit() {

/*    if (this.markss.length == 0) {
      this.submitSwal.show();

      return false;

    } else if (this.markss.length != this.students.length) {
      this.submitSwal.show();    

      return false;
    }*/
    //var marks = JSON.stringify(this.markss)
    //this.studentService.setPracMarks(this.globals.root_url, this.localData['usercode'], this.student_id, this.practical_id, this.localData['id'], this.localData['exam_id'], this.comments.value, marks, this.maxMarks)
    this.studentService.setPracMarks(this.globals.root_url, this.localData['usercode'], this.student_id, this.practical_id, this.localData['id'], this.localData['exam_id'], this.comments.value, this.maxMarks)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.status = data.status
            this.successSwal.show();

          }
          else if (data.code == 1001) {
            this.isError = true;
            this.errorMsg = 'You do not have any Particular !!';
            this.router.navigateByUrl('/practical-list');

          }
          else (data.status == 'COM_TOKEN_ERROR')
          this.loading = false;
          this.router.navigateByUrl('/practical-list');



        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );

    // }


  }
  public gotoDashboard() {
    this.router.navigateByUrl('/home/' + this.localData['exam_id']+'/'+this.localData['viva_assessor']+'/'+this.localData['viva_pc']);
  }

  public practical() {
    this.router.navigateByUrl('/practical-list');

  }





}
